import { render } from "./ImportMatiere.vue?vue&type=template&id=570dad02"
import script from "./ImportMatiere.vue?vue&type=script&lang=js"
export * from "./ImportMatiere.vue?vue&type=script&lang=js"

import "./ImportMatiere.vue?vue&type=style&index=0&id=570dad02&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__